/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2021-07-06 20:10:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-10-23 16:17:51
 */
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./views/routes";
import * as serviceWorker from "./serviceWorker";
import intl from "react-intl-universal";
import en from "i18n/en.js";// 英语
import id from "i18n/js/id";// 印度尼西亚语
import ru from "i18n/js/ru";// 俄语


let lang =  (navigator.languages && navigator.languages[0]) || navigator.language;
let langUse: string;

// lang='en'

// 设置语言
if (lang.split("-")[0].toLowerCase() === "id") {
  langUse = 'id'
} else if (lang.split("-")[0].toLowerCase() === "ru") {
  langUse = 'ru'
} else {
  langUse = "en";
}

intl.init({
  currentLocale: langUse,
  locales: {
    en,id,ru
  },
});

// 埋点----打开H5活动链接
gtag("event", "free film sevice pagaview");
ath_send("cc_H5_active_show", {
  active: "free film sevice",
  name: "free film sevice pagaview"
})

//判断浏览器是否支持 speculationrules
if (HTMLScriptElement.supports?.('speculationrules')) {
  const specScript = document.createElement('script');
  specScript.type = 'speculationrules';
  let specRules = {
    prerender: [
      {
        source: 'list',
        urls: ['/landing','/order','/model'],
      },
    ],
  };
  specScript.textContent = JSON.stringify(specRules);
  document.body.append(specScript);
}

ReactDOM.render(<App />, document.getElementById("root"));


serviceWorker.unregister();
